import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetosanglicabs() {



  const cardData =
  {
    keyword: 'Pune to Sangli Cabs',
    heading: 'Sai Trupti Cabs: Pune to Sangli Cabs',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pune to Sangli cab hire services, designed to make your inter-city journey smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all equipped with clean interiors and ample luggage space. Every journey is driven by a professional, background-verified chauffeur who ensures punctual pickup in Pune, courteous service, and safe, smooth driving all the way to Sangli. With transparent one-way fares, flexible booking options (one-way or round-trip), and 24×7 customer support, Sai Trupti Cabs makes your travel from Pune to Sangli convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Sangli with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Ganapati Temple, Sangli",
    "description": "The Ganapati Temple in Sangli, built in 1843 by Thorle Chintamanrao Patwardhan, is a revered shrine dedicated to Lord Ganesha, the guardian deity of the region. Its striking black-stone architecture spreads over two acres and stands as a symbol of faith and devotion in the heart of the city. Devotees gather here daily to seek blessings, partake in aarti and feel the temple’s spiritual hum. The temple’s halls echo with songs of hope and laughter of families visiting together. During festivals, the complex glows with lamps and flowers, and local treats add to the festive mood. A visit here connects you to Sangli’s religious rhythm, heritage and quiet power."  
  },
  {
    "title": "Sangmeshwar Temple at the Confluence",
    "description": "The Sangmeshwar Temple stands beautifully at the meeting point of the Krishna and Warna rivers in Sangli, offering both spiritual calm and scenic water views. Dedicated to Lord Shiva, the temple’s ancient stone structure and river-bank setting create a meditative ambiance far from the urban bustle. Pilgrims come to offer prayers, watch the flowing waters and breathe in the cool breeze. The surrounding ghats and shaded benches invite quiet reflection, while the river’s gentle murmur adds natural music to the sacred space. The temple is a serene anchor for Sangli’s soul — where devotion and nature meet."  
  },
  {
    "title": "Sagareshwar Wildlife Sanctuary",
    "description": "Located near Palus/Kadegaon in Sangli district, the Sagareshwar Wildlife Sanctuary is a green haven of forests, hills and wildlife just away from city noise. Spread across rolling terrain, the sanctuary protects deer, blackbucks, peacocks and a host of birds, offering visitors a chance to reconnect with nature. Numerous small temples from the Chalukya period add historical charm to the trails. As you climb the hill-tops, you’re rewarded by expansive views of the sugar-cane and grape-vine fields of Sangli stretching to the horizon. It’s a place where ecology, culture and outdoor peace converge beautifully."  
  },
  {
    "title": "Chandoli National Park",
    "description": "The Chandoli National Park in Sangli district forms part of the Sahyadri Tiger Reserve and is a crucial corridor of Western Ghats biodiversity. Lush forests, monsoon streams, plateau rocks and hidden waterfalls create a landscape of raw nature and adventure. The park is home to leopards, gaur (Indian bison), sloth bears and a rich variety of birds — making it ideal for wildlife enthusiasts and trekkers alike. Walking its trails at dawn brings misty hilltops and the call of the forest alive. Chandoli reveals Sangli’s wild side, a reminder that beyond vineyards and temples lies deep wilderness."  
  },
  {
    "title": "Dandoba Hills Forest Preserve",
    "description": "Dandoba Hills, near Miraj in the Sangli district, rise gently above the plains and offer refreshing vistas, monsoon waterfalls and quiet wooded walks. The forest preserve is perfect for an early morning drive or trekking trip, where you’ll find local villagers’ coffee stalls, winding roads through green cover and misty skies in the rainy season. It’s an ideal getaway from urban life, with nature’s aroma, chirping birds and panoramic views that feel like a secret tucked away from the mainstream. For those staying in Sangli city, Dandoba offers a swift escape into tranquility."  
  },
  {
    "title": "Shukachari and Mahadeva Hills",
    "description": "Shukachari, located in Khanapur/Atpadi taluka of Sangli, lies amidst the Mahadeva Hills and has legend and nature intertwined. According to local lore, the sage Shuka vanished here, and the site includes caves, a temple of Lord Shiva and an eternal spring (‘Jivant Zhara’) flowing from the mountain rock. The narrow forest roads, old stone structures and surrounding hills impart an atmosphere of sacred solitude. During the monsoon, the rocks glisten, the forest breathes fresh, and the gentle gurgle of streams guides your walk. Shukachari becomes a pilgrimage of peace and discovery in Sangli’s lesser-known corners."  
  },
  {
    "title": "Sangli Fort & Riverfront (Krishna River) ",
    "description": "Sangli Fort, along with the nearby Irwin Bridge over the Krishna River, stands as a fragment of the city’s historical identity. Although modest compared to grand forts, the site offers sweeping views of river flows, old walls, and the gentle rhythm of city-life meeting the water. Evening strolls along the riverside, watching the boats and light reflections, evoke calm and local warmth. The riverfront area with its ghats, benches and food stalls becomes a lively place to witness local culture. Sangli Fort and the Kishna riverside remind you that the city’s connection to water has shaped its character."  
  },
  {
    "title": "Bahubali Hill Temple & Shirala Hills",
    "description": "Near Shirala in Sangli district rises the hill of Bahubali, where atop sits a temple and colossal statue of Lord Bahubali — a serene vantage point over the green valleys below. The climb through forested footpaths rewards you with sweeping panoramas, bird-song and a spiritual hush. The site sees fewer tourists, lending it a peaceful atmosphere for meditation, photography and simply breathing deep. It reflects Sangli’s mixed heritage of faith, nature and hills — a space where time slows and presence deepens."  
  },
  {
    "title": "Aamrai Garden & Miraj Area",
    "description": "Aamrai Garden near Miraj in Sangli district is a beloved green space for locals and visitors, with its lawns, play zones, river-views and shady trees. It’s ideal for families, couples, and those wanting a gentle walk amid nature without leaving the city. The pleasant ambiance, light breeze off the river, and gardens in bloom make it a nice stop while exploring Sangli’s urban and semi-urban side. Aamrai reminds you that Sangli is not just fields and temples — it’s also about everyday places to relax, connect and reflect."  
  }
],



"services": [
  {
    "name": "Pune to Sangli Cabs",
    "description": "Book comfortable Pune to Sangli cabs for a safe, hassle-free journey. Choose from AC and non-AC vehicles including Sedans, SUVs, and luxury cars. Travel with experienced drivers familiar with long-distance routes, enjoy flexible pickup and drop points, and benefit from transparent pricing. Perfect for family trips, weekend getaways, group travel, or corporate journeys, with easy online booking, instant confirmation, and 24/7 support ensuring a smooth ride."
  },
  {
    "name": "Pune to Sangli Taxi Service",
    "description": "Hire a Pune to Sangli taxi for a stress-free and scenic journey. Well-maintained vehicles, courteous drivers, and flexible schedules make it ideal for tourists, business travelers, and families. One-way or round-trip options are available with transparent fare policies."
  },
  {
    "name": "Pune to Sangli Car Hire",
    "description": "Rent a car from Pune to Sangli for personalized and comfortable travel. Choose from Sedans, SUVs, and luxury vehicles with AC/non-AC options. Benefit from professional drivers, luggage assistance, flexible routes, and safe travel. Ideal for families, groups, or business trips seeking convenience and comfort."
  },
  {
    "name": "AC Cab Pune to Sangli",
    "description": "Travel comfortably with AC cab service from Pune to Sangli. Enjoy clean, air-conditioned vehicles, skilled drivers, flexible pickup points, and smooth, safe travel. Suitable for families, couples, and solo travelers looking for a relaxed long-distance journey."
  },
  {
    "name": "Non AC Cab Pune to Sangli",
    "description": "Affordable non-AC cab service from Pune to Sangli for budget-conscious travelers. Reliable drivers, well-maintained cars, and flexible pickup/drop points ensure safe, comfortable, and economical travel over long distances."
  },
  {
    "name": "Innova Cab Pune to Sangli",
    "description": "Book spacious and comfortable Innova cabs from Pune to Sangli. Ideal for families or groups, featuring AC comfort, ample legroom, luggage space, and experienced drivers. Enjoy smooth travel on highways and city roads for a stress-free journey."
  },
  {
    "name": "Ertiga Cab Pune to Sangli",
    "description": "Affordable and convenient group travel with Ertiga cabs from Pune to Sangli. AC/non-AC options, comfortable seating, luggage space, and professional drivers ensure a safe and enjoyable ride. Perfect for friends, families, or corporate groups."
  },
  {
    "name": "Luxury Cab Pune to Sangli",
    "description": "Travel in style with luxury cab services from Pune to Sangli. Premium Sedans and SUVs with elegant interiors, AC service, and professional chauffeurs make it ideal for VIP guests, business executives, or special occasions. Experience comfort, safety, and prestige throughout the journey."
  },
  {
    "name": "Affordable Cab Pune to Sangli",
    "description": "Get pocket-friendly Pune to Sangli cab services with transparent fares, AC/non-AC options, and professional drivers. Flexible timings, easy booking, and reliable service make it perfect for solo travelers, students, and small families looking for value-for-money travel."
  },
  {
    "name": "Pune to Sangli Outstation Cab",
    "description": "Reliable outstation cab service from Pune to Sangli ideal for weekend trips, sightseeing, or long stays. Choose from a variety of vehicles, enjoy AC/non-AC comfort, flexible bookings, and safe travel with experienced drivers for a hassle-free interstate journey."
  },
  {
    "name": "Pune to Sangli One Way Cab",
    "description": "Book one-way cabs from Pune to Sangli at affordable rates. Point-to-point travel, clean vehicles, professional drivers, and flexible pickups make it ideal for travelers heading to Sangli without return plans."
  },
  {
    "name": "Pune to Sangli Drop Cab",
    "description": "One-way drop cab service from Pune to Sangli with flexible timings, AC/non-AC options, and professional drivers. Enjoy a smooth, comfortable ride perfect for single transfers, business trips, or leisure travel."
  },
  {
    "name": "Corporate Cab Pune to Sangli",
    "description": "Premium corporate cab hire from Pune to Sangli with executive vehicles, professional chauffeurs, and flexible travel schedules. Ideal for conferences, business meetings, client visits, and corporate events, offering comfort, punctuality, and reliability."
  },
  {
    "name": "Wedding Cab Pune to Sangli",
    "description": "Elegant wedding cab service from Pune to Sangli with luxury interiors, AC comfort, professional drivers, and on-time pickups. Perfect for bride/groom transfers, guest transport, and event logistics with complete reliability and style."
  },
  {
    "name": "Online Cab Booking Pune to Sangli",
    "description": "Book your Pune to Sangli cab online with instant confirmation, secure payment, and transparent fares. Choose from Sedans, Innova, and Ertiga for a convenient, stress-free journey. Ideal for last-minute travel, weekend trips, or planned travel with complete convenience."
  }
],
"tableData": [
  ["Pune to Sangli Cabs", "Pune to Sangli Taxi Service"],
  ["Pune to Sangli Car Hire", "AC Cab Pune to Sangli"],
  ["Non AC Cab Pune to Sangli", "Innova Cab Pune to Sangli"],
  ["Ertiga Cab Pune to Sangli", "Luxury Cab Pune to Sangli"],
  ["Affordable Cab Pune to Sangli", "Pune to Sangli Outstation Cab"],
  ["Pune to Sangli One Way Cab", "Pune to Sangli Drop Cab"],
  ["Online Cab Booking Pune to Sangli", "Corporate Cab Pune to Sangli"],
  ["Wedding Cab Pune to Sangli", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Sangli Cabs",
    "WhyChoosedescription": "Sai Trupti Cabs offers reliable and comfortable cab services from Pune to Sangli — perfect for family travel, business trips, temple visits, or leisure journeys across Maharashtra."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Get affordable and transparent fares for Pune to Sangli cabs — no hidden charges, no surge pricing, and complete value for your money."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and premium cars based on your comfort, group size, and budget for the Pune–Sangli route."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and trained drivers are familiar with the Pune to Sangli route, ensuring a safe, smooth, and timely travel experience."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "Enjoy flexible pickups from anywhere in Pune — airport, railway station, home, or office — and convenient drop-offs at your desired location in Sangli."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "Sai Trupti Cabs maintains a fleet of clean, sanitized, and regularly serviced vehicles to ensure a comfortable and reliable journey every time."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated customer support team is available 24/7 to assist you with bookings, route information, or travel assistance for your Pune to Sangli cab trip."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Sangli cab easily via call, WhatsApp, or our website — get instant confirmation and on-time cab service without any hassle."
  }
]
































  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs offer Pune to Sangli cab services?',
    answer: 'Yes, Sai Trupti Cabs provides safe, reliable, and affordable Pune to Sangli cab services for one way, round trips, and business or personal travel.',
  },
  {
    question: 'How can I book a Pune to Sangli cab with Sai Trupti Cabs?',
    answer: 'You can easily book your Pune to Sangli cab through our website, mobile app, or by contacting our 24×7 customer support team for instant booking assistance.',
  },
  {
    question: 'What types of cabs are available from Pune to Sangli?',
    answer: 'We offer a range of well-maintained vehicles including hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers—ideal for families, groups, and solo travelers.',
  },
  {
    question: 'Are the drivers experienced for Pune to Sangli routes?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced with the Pune–Sangli route, ensuring a comfortable and safe travel experience.',
  },
  {
    question: 'Can I book a cab for local sightseeing in and around Sangli?',
    answer: 'Of course! Sai Trupti Cabs offers local sightseeing packages in Sangli for attractions like Sagareshwar Wildlife Sanctuary, Ganpati Temple, and Krishna Valley.',
  },
  {
    question: 'Is the Pune to Sangli cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs operates 24×7 Pune to Sangli cab services so you can plan your trip anytime according to your convenience.',
  },
  {
    question: 'What are the Pune to Sangli cab fares?',
    answer: 'Our Pune to Sangli cab fares start from ₹1,800 for sedans and ₹2,500–₹3,200 for SUVs or Innova Crysta, depending on your travel plan and vehicle choice.',
  },
  {
    question: 'What payment options are available for Pune to Sangli cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for a seamless and secure transaction experience.',
  },
  {
    question: 'What safety and hygiene measures are followed for Pune to Sangli cabs?',
    answer: 'All our cabs are sanitized before each ride, and our drivers follow strict hygiene and safety protocols to ensure a worry-free journey.',
  },
  {
    question: 'Is customer support available during the Pune to Sangli cab journey?',
    answer: 'Yes, Sai Trupti Cabs provides round-the-clock customer support to assist you during your Pune to Sangli trip.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Vijay Shinde',
    feedback: 'Traveling from Pune to Sangli with Sai Trupti Cabs was comfortable and hassle-free. The driver was professional and the cab was clean.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Rekha Patil',
    feedback: 'Excellent service for Pune to Sangli. Punctual pickup, safe driving, and very courteous driver made our trip memorable.',
    rating: 5,
  },
];





























































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];

















const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Pune to Sangli Cab Service",
  "image": "https://saitrupticabs.com/assets/images/pune-to-sangli-cab.jpg",
  "description": "Sai Trupti Cabs offers Pune to Sangli cab service with one way taxi, round trip cabs, sedan, SUV, Ertiga and Innova Crysta options. Book affordable outstation cabs with professional drivers, 24x7 service and safe, comfortable travel experience.",
  "provider": {
    "@type": "Organization",
    "name": "Sai Trupti Cabs",
    "url": "https://saitrupticabs.com"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Pune to Sangli"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8120"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2499",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-sangli-cab-booking",
    "itemCondition": "https://schema.org/NewCondition"
  }
};





  return (
    <div>
<Helmet>
  <title>Pune to Sangli Cab Service | One Way Taxi ₹2499 | Sai Trupti Cabs</title>

  <meta 
    name="description" 
    content="Book Pune to Sangli cab at best price ₹2499 with Sai Trupti Cabs. One way taxi, round trip, Innova Crysta, Ertiga, sedan & SUV available. Safe, affordable and 24x7 cab service." 
  />

  <meta 
    name="keywords" 
    content="pune to sangli cab, pune to sangli taxi, pune to sangli cab service, pune to sangli one way cab, pune to sangli taxi fare, pune to sangli innova crysta, pune to sangli ertiga cab, pune to sangli sedan cab, cheap pune to sangli cab, best cab service pune to sangli, pune to sangli drop taxi, pune to sangli round trip cab, outstation cab pune to sangli, pune to sangli online cab booking" 
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/80.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetosanglicabs;